export default __webpack_public_path__ + "static/media/holidaymode1024.84511776.png";